<footer class="footer">
    <small class="font-franklin-medium">ARIS © COPYRIGHT.TODOS LOS DERECHOS RESERVADOS</small>
</footer>  